<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    reload() {
      
      this.isRouterAlive = false //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开 
      })
    },
  },
}
</script>

<style lang="scss">
body {
  margin: 0 !important;
  font-family: 'Microsoft YaHei';
  font-size: 14px !important;
}
#app {
  padding: 0;
  margin: 0;
  .el-select-dropdown__item.selected {
    color: var(--primary-color);
  } 
}
body .el-table th.gutter {
  display: table-cell !important;
}

</style>
